"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _createReactClass = _interopRequireDefault(require("create-react-class"));

var CustomRenderer = _interopRequireWildcard(require("UIComponents/utils/propTypes/customRenderer"));

var _createLazyPropType = _interopRequireDefault(require("UIComponents/utils/propTypes/createLazyPropType"));

var _lazyEval = _interopRequireDefault(require("UIComponents/utils/lazyEval"));

var _classnames = _interopRequireDefault(require("classnames"));

var _default = (0, _createReactClass.default)({
  displayName: "SingleNameInput",
  propTypes: {
    input: CustomRenderer.propType.isRequired,
    label: (0, _createLazyPropType.default)(_propTypes.default.node).isRequired
  },
  render: function render() {
    var _this$props = this.props,
        className = _this$props.className,
        input = _this$props.input,
        label = _this$props.label,
        passThroughProps = (0, _objectWithoutProperties2.default)(_this$props, ["className", "input", "label"]);
    var inputClass = input.props && input.props.className;
    return CustomRenderer.render(input, Object.assign({
      label: (0, _lazyEval.default)(label)
    }, passThroughProps, {}, input.props, {
      className: (0, _classnames.default)(inputClass, className)
    }), {
      mergeType: 'aggressive'
    });
  }
});

exports.default = _default;
module.exports = exports.default;